export const SUPPORT_EMAIL = "info@geneto.net";
